import initialState from "../../../config/initialState";

const initialFormData = Object.assign({}, initialState, {
  data: {
    profileInfo: {
      first_name: "",
      last_name: "",
      email: "",
      job_title: "",
      industry: "",
      subscriptionIds: [],
      savedStoryIds: [],
      saved_stories: [],
      linkedin: "",
      facebook: "",
      twitter: "",
    },
    subscriptions: [],
  },
});

export default initialFormData;



// WEBPACK FOOTER //
// ./src/users/reducers/initialState/userSettings.js